import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import FormSection from '../form-section/FormSection';
import MessagesList from '../messages-list/MessagesList';
import PredictedMessage from './predicted-message/PredictedMessage';
import PredictForm from './predict-form/PredictForm';
import { COMMON_GENIE_SORT } from '../../../hooks/useGenieMessagesSort';
import useLocalSort from '../../../hooks/useLocalSort';
import { GENIE_EVALUATE_TYPE } from '../../../constants';
import PredictFilters from './predict-filters/PredictFilters';

import scss from './PredictResponse.module.scss';

function PredictResponse({ onPredictResponse, onGenerateAlternate }) {
  const { t } = useTranslation('genie');

  const [isShowForm, setIsShowForm] = useState(true);
  const [sort, setSort] = useState(COMMON_GENIE_SORT);

  const predictedMessages = useSelector((state) => state.genie.predictedMessages);
  const isPredicting = useSelector((state) => state.genie.isPredicting);
  const isGeneratingAlternate = useSelector((state) => state.genie.isGeneratingAlternate);
  const evaluateActions = useSelector((state) => state.genie.evaluateActions);

  const sortedMessages = useLocalSort({ content: predictedMessages, sort: sort });

  const handleChangeForVisibility = () => {
    setIsShowForm((prevState) => !prevState);
  };

  const handleChangeSort = ({ sort, direction, getSortValue }) => {
    setSort({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.sectionWrapper}>
      <FormSection isShowForm={isShowForm} onChangeVisibility={handleChangeForVisibility} hideLabel={t('predictForm')}>
        <PredictForm onPredictResponse={onPredictResponse} onGenerateAlternate={onGenerateAlternate} />
      </FormSection>

      <PredictFilters onSort={handleChangeSort} sort={sort} />

      <MessagesList
        content={sortedMessages}
        className={scss.listWrapper}
        renderMessage={(message) => (
          <PredictedMessage
            key={`${message.message}-${message.count}`}
            message={message}
            isLoading={evaluateActions[GENIE_EVALUATE_TYPE.ALTERNATE].pending}
          />
        )}
        isLoading={isPredicting || isGeneratingAlternate}
      />
    </div>
  );
}

export default PredictResponse;
